const swrConfig = {
    // 初回のfetchのみ行い、以降はキャッシュを返すoption
    Immutable: {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    },
    // chat専用のoption
    chat: {
        refreshInterval: 30000,
    },
};

export default swrConfig;
